export default "__VITE_ASSET__1824c2bb__"